{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Seleccionar un artículo",
  "tableResizer": "Cambiador de tamaño",
  "colorSwatchPicker": "Color swatches"
}
